<template>
  <div>
    <div class="d-flex flex-stack flex-wrap">
        <div class="page-title d-flex flex-column me-3 mt-3"> 
            <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('create_product_detail') }}
            </h1>
            <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                <li class="breadcrumb-item text-gray-600">
                    <a href="#" class="text-gray-600 text-hover-primary">
                        <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                    </a>
                </li> 
                <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">{{ $t('settings') }}</router-link></li>
                <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'ListTypes' }">{{ $t('list_types') }}</router-link></li>
                <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'ProductDetailList' }">{{ $t('product_detail') }}</router-link></li> 
                <li class="breadcrumb-item text-gray-600">{{ $t('create_product_detail') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                </li>  
            </ul> 
        </div>  
        <div class="d-flex align-items-center py-1">
            <router-link to="/ProductDetailList">
                <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                <span class="ms-2 fs-7"> {{ $t('return_back_to_list') }}</span>
                </button>
            </router-link> 
        </div>
    </div>
    <div class="content flex-row-fluid mt-6" id="kt_content">
        <RequiredField></RequiredField>
        <div class="card card-xxl-stretch">
            <div class="row p-10">
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="kt_accounting_1" role="tabpanel">
                        <div class="row">
                            <div class="col-lg-12 mt-0"> 
                            <div class="d-flex flex-row row">
                                <div class="d-flex flex-column flex-row-auto col-lg-6"> 
                                    <div class="d-flex flex-column-fluid card card-xxl-stretch mb-xxl-6 bg-lighten border border-gray-300">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <label class="fs-6 fw-bold form-label mt-3 required">
                                                        <span>{{ $t('product_type') }}</span>
                                                    </label>
                                                    <Select2 v-model="form.product_type_id" :options="productTypeList" :settings="{ width: '100%' }"/> 
                                                </div>
                                                <div class="col-lg-12">
                                                    <label class="fs-6 fw-bold form-label mt-3 required">
                                                        {{ $t('code') }}
                                                    </label>
                                                    <input type="text" class="form-control " name="code"
                                                        v-model="form.code">
                                                </div>
                                                <div class="col-lg-12">
                                                    <label class="fs-6 fw-bold form-label mt-3 required">
                                                        {{ $t('name') }}
                                                    </label>
                                                    <input type="text" class="form-control " name="name"
                                                        v-model="form.name">
                                                </div>
                                            </div> 
                                        </div>
                                    </div> 
                                </div>
                                <div class="d-flex flex-column flex-row-auto col-lg-6"> 
                                    <div class="d-flex flex-column-fluid card card-xxl-stretch mb-xxl-6 bg-lighten border border-gray-300">
                                        <div class="card-body">
                                            <div class="row">                                                
                                                <div class="col-lg-12">
                                                    <label class="fs-6 fw-bold form-label mt-3">
                                                        <span>{{ $t('description') }}</span>
                                                    </label>
                                                    <textarea rows="4" class="form-control " name="description" v-model="form.description"></textarea>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="form-check mt-5">
                                                        <input class="form-check-input fs-6 fw-bold form-label mt-3" type="checkbox" value="" id="isDefault" v-model="form.is_default">
                                                        <label class="fs-6 fw-bold form-label mt-3" for="isDefault">
                                                            {{ $t('default') }}
                                                        </label>
                                                    </div> 
                                                </div>
                                            </div> 
                                        </div>
                                    </div> 
                                </div>
                            </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="d-grid gap-2">
                                    <button type="button" class="btn btn-success" @click="this.saveData()" data-kt-indicator="on">
                                        <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                        <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                        </svg>
                                        </span> 
                                        <strong v-if="!this.isProgressing"> {{ $t('save_product_detail') }}</strong> 
                                            <span class="indicator-progress" v-if="this.isProgressing">
                                                {{ $t('saving_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span> 
                                    </button>
                                </div>                  
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// Component Alias: `PROC001`
import axios from 'axios'  
 
 
 
export default {
  name: "ProductDetailCreate",
  data() {
    return {
        productTypeList: [{ id: '-1', text: this.$t('select_an_option')}],
        isProgressing: false,
        form: { 
          name: null,
          code: null,
          description: null,
          session_id: null,
          is_default: false,
          product_type_id: '-1'
        },
        menuSelection: '/ProductDetailHelppage',
        iconView : false
    };
  },
  methods: { 
    getData(){
      this.$setSessionStorage('refreshList', true);
      this.$Progress.start();
      const params = { 
            session_id: this.$getUser().session_id,
            list_name: [ "product_type"],
        }; 
        axios.post('/api/Helper/GeneralLists', params, {'Content-Type': 'application/json'}).then((response) => {
        this.productTypeList = response.data.product_type;
        this.productTypeList.unshift({ id: '-1', text: this.$t('select_an_option')});
        this.$Progress.finish();
        })
        .catch((error) => {
          console.error(error); 
          this.$Progress.finish();
        });
    },
    saveData(){
      this.isProgressing = true;
      const params = {
        name: this.form.name,
        code: this.form.code,
        description: this.form.description,
        session_id: this.$getUser().session_id,
        is_default: this.form.is_default,
        product_type_id: this.form.product_type_id
      }
      const that = this;   
      params.session_id = this.$getUser().session_id;
      if(params.is_default){ params.is_default = 1; }else{ params.is_default = 0; }
      if(params.product_type_id == '-1'){ params.product_type_id = null;}
      axios.post('/api/ProductDetail/CreateProductDetail', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(response.data != null && response.data.length == 36){  
                this.$swal(this.$t('success'), this.$t('data_saved_succesfully'), 'success');  
                this.$setSessionStorage('record_id', response.data);
                this.$setSessionStorage('refreshList', true); 
                this.$router.push({ name: 'ProductDetailUpdate' });
            }
        })
        .catch((error) => {
            console.error(error);
            this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), "error");   
        })
        .finally(() => { 
            setTimeout(() => {
                that.isProgressing = false;
            }, 500);
        });   
      },
    async helpPageViewIcon()
    {
        const queryparameter = {
            session_id : this.$getUser().session_id,
            menu_selection : '/ProductDetailHelppage'
        };
        axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(!response.data.error){ 
                this.iconView = response.data;
            }
        })
    }, 
  },
  created() {
    this.helpPageViewIcon();
    this.$setSessionStorage('refreshList', true);
    this.getData();
  }
}; 
</script>